import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col } from 'react-flexbox-grid';
import { TransitionEaseInOne } from '../common/transitions';
import Button from '../common/button';
import { generateAppEssentialPayload } from '../../helpers/filterConversions';
import { appEssentialFetch } from '../../actions';

// Import hero and collage images
const heroImg = 'https://static.wixstatic.com/media/c20397_24bdffb9ee2544588a079005f768a2d9~mv2.png/v1/fill/w_2160,h_813,al_c,q_90,enc_avif,quality_auto/c20397_24bdffb9ee2544588a079005f768a2d9~mv2.png';
import img1 from '../images/farmfit/AKB03874.jpg';
import img2 from '../images/farmfit/AKB03961.jpg';
import img3 from '../images/farmfit/DSC02216.jpg';
import img4 from '../images/farmfit/DSC07460.jpg';

const FarmFitHomePage = (props) => {
    useEffect(() => {
        props.appEssentialFetch(
            generateAppEssentialPayload({
                objectType: "recipe",
            })
        );
    }, []);
    return (
        <>
            <Helmet>
                <title>Farm Fit Nutrition | Your Macro-Balanced Meal Hub</title>
                <meta name="description" content="Farm Fit Nutrition - Your exclusive hub for macro-balanced, real-food meals designed to fuel your life and results." />
            </Helmet>
            <section className="farmfit-hero-section">
                <img src={heroImg} alt="Farm Fit Hero" className="farmfit-hero-img" />
                <div className="farmfit-hero-overlay">
                    <h1>Welcome to Nutrition by FarmFit</h1>
                    <p>Your home for realistic, macro-friendly recipes, meal plans, and simple nutrition support.</p>
                    <Button
                        btnClass="primary btn-lg"
                        btnText="Get Started"
                        onClick={() => window.location.href = '/recipes'}
                    />
                </div>
            </section>
            <section className="farmfit-home-section">
                <div className="container">
                    <Row>
                        <Col xs={12} md={8} mdOffset={2}>
                            <TransitionEaseInOne>
                                <div className="farmfit-home-content">
                                    <div className="intro-text">
                                        <p>
                                            This app makes it easy to fuel your goals while enjoying real food that fits your life.
                                            Whether you're training hard or maintaining, you'll find meals that work.
                                        </p>
                                    </div>
                                    <div className="tracking-steps">
                                        <h2>How to track meals in the FFT app:</h2>
                                        <ol>
                                            <li>Tap <strong>Macros</strong> → + Add Meal</li>
                                            <li>Skip photo</li>
                                            <li>Scroll to <strong>Custom</strong> → + Add Custom</li>
                                            <li>Enter recipe name, serving size, calories & macros</li>
                                        </ol>
                                    </div>
                                    <div className="">
                                        That’s it — fast, clean, and client-tested.
                                    </div>
                                </div>
                            </TransitionEaseInOne>
                        </Col>
                    </Row>
                </div>
            </section>
            <section className="farmfit-collage-section">
                <img src={img1} alt="Farm Fit 1" className="collage-img" />
                <img src={img2} alt="Farm Fit 2" className="collage-img" />
                <img src={img3} alt="Farm Fit 3" className="collage-img" />
                <img src={img4} alt="Farm Fit 4" className="collage-img" />
            </section>
        </>
    );
};

const mapStateToProps = (state) => ({
    userDetails: state.getIn(["user", "userDetails"]),
});

const dispatchActionToProps = (dispatch) => ({
    appEssentialFetch: bindActionCreators(appEssentialFetch, dispatch),

});

export default connect(mapStateToProps, dispatchActionToProps)((FarmFitHomePage));
